export const _en = {
    name: {
        label: "Name"
    },
    refGlobalStateId: {
        label: "State"
    },
    season: {
        label: "Season"
    },
    version: {
        label: "Version"
    },
    startDate: {
        label: "Start validity date"
    },
    finishDate: {
        label: "End validity date"
    },
    numberOfWeeks: {
        label: "Number of weeks"
    },
    numberOfDaysPerWeek: {
        label: "Number of days per weeks"
    },
    resourceId: {
        label: "Resource"
    },
    timetableId: {
        label: "Time table"
    },
    weekNumber: {
        label: "Week number"
    },
    usableVacationIds: {
        label: "Usable vacations"
    },
    contractTime: {
        label: "Contract time"
    },
    refDivisionId: {
        label: "Division"
    }
};

export const _fr = {
    name: {
        label: "Libellé"
    },
    refGlobalStateId: {
        label: "État"
    },
    season: {
        label: "Saison"
    },
    version: {
        label: "Version"
    },
    startDate: {
        label: "Date de début de validité"
    },
    namedResStartDate: {
        label: "Date de début d’affectation"
    },
    finishDate: {
        label: "Date de fin de validité "
    },
    namedResFinishDate: {
        label: "Date de fin d’affection"
    },
    numberOfWeeks: {
        label: "Nombre de semaine(s)"
    },
    numberOfDaysPerWeek: {
        label: "Nombre de jour(s) par semaine"
    },
    resourceId: {
        label: "Ressource"
    },
    timetableId: {
        label: "Grille horaire"
    },
    weekNumber: {
        label: "Numéro de semaine d'accrochage"
    },
    usableVacationIds: {
        label: "Vacations contraintes"
    },
    contractTime: {
        label: "Taux horaire hebdomadaire"
    },
    refDivisionId: {
        label: "Service"
    }
};